import classnames from 'classnames';
import React from 'react';
import { Grid, GridCell } from 'shared';

import styles from './Empty.module.scss';

type EmptyProps = {
  Icon?: React.FC;
  title?: string;
  description?: string;
};

const Empty = ({ Icon, title, description }: EmptyProps) => {
  return (
    <Grid align="center" valign="center" cellPadding="xl">
      <GridCell>
        <div className={styles.Empty}>
          {Icon && (
            <div className="stack-s inline-block mb-4">
              <Icon />
            </div>
          )}
          {title && (
            <div className={classnames(styles.Title, 'stack-xs')}>{title}</div>
          )}
          {description && (
            <div className={styles.Description}>{description}</div>
          )}
        </div>
      </GridCell>
    </Grid>
  );
};

export default Empty;
